import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"];

  changeOption(e) {
    const url = e.target.value;
    Turbolinks.visit(url);
  }

}
